import { Component } from '@angular/core';

@Component({
    selector   : 'bh-demo-content',
    templateUrl: './demo-content.component.html',
    styleUrls  : ['./demo-content.component.scss']
})
export class BhDemoContentComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
